export const resumeFormsToken = 'resumeForms:';
